import { FGM } from "../brand";
import ShareButton from "./ShareButton";
import ResponsiveImage from "./ResponsiveImage";

export default function Lookbook() {
    const items = [
        { src: "/lookbook/crossfit.webp", label: "CROSSFIT", tag: "01" },
        { src: "/lookbook/track.webp", label: "TRACK & FIELD", tag: "02" },
        { src: "/lookbook/football-cycling.webp", label: "FOOTBALL & CYCLING", tag: "03" },
        { src: "/lookbook/soccer.webp", label: "SOCCER", tag: "04" },
    ];

    return (
        <section
            id="lookbook"
            data-testid="lookbook-section"
            className="relative bg-fgm-dark py-16 md:py-24 overflow-hidden"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-10">
                <div className="flex items-end justify-between mb-12 flex-wrap gap-6">
                    <div>
                        <div className="flex items-center gap-4 mb-4">
                            <span className="h-px w-12 bg-[#1D4ED8]" />
                            <span className="font-display tracking-[0.35em] text-zinc-400 text-sm uppercase">
                                / 03 — The Lookbook
                            </span>
                        </div>
                        <h2
                            data-testid="lookbook-title"
                            className="font-display uppercase text-white text-5xl md:text-7xl leading-[0.9] tracking-tight max-w-3xl"
                        >
                            Built For{" "}
                            <span className="font-outline-strong">Every</span>{" "}
                            Athlete
                        </h2>
                    </div>
                    <p className="text-zinc-400 max-w-sm font-body">
                        From CrossFit boxes to the track, the gridiron to the
                        pitch to the open road — FGM is built for anyone who
                        moves with purpose.
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-6">
                    {/* HERO — CrossFit */}
                    <div
                        data-testid="lookbook-image-0"
                        className="lookbook-card md:col-span-8 md:row-span-2 aspect-square bg-black"
                    >
                        <ShareButton
                            eventLabel={`lookbook-${items[0].label}`}
                            title={`FGM Apparel — ${items[0].label}`}
                            text={`${items[0].label} · Built for athletes. Focus. Grind. Motivate.`}
                            path="#lookbook"
                            image={items[0].src}
                        />
                        <ResponsiveImage
                            src={items[0].src}
                            alt={items[0].label}
                            sizes="(max-width: 768px) 100vw, 800px"
                            eager
                            fetchPriority="high"
                            className="w-full h-full object-contain"
                        />
                        <div className="absolute bottom-0 left-0 p-6 md:p-8 bg-gradient-to-t from-black via-black/70 to-transparent w-full">
                            <div className="fgm-stripe-divider w-10 mb-3" />
                            <div className="text-xs font-display tracking-[0.3em] text-zinc-300 mb-2">
                                {items[0].tag}
                            </div>
                            <div className="font-display text-3xl md:text-5xl text-white uppercase tracking-tight">
                                {items[0].label}
                            </div>
                        </div>
                    </div>

                    {/* Side — Track & Field (full-height) */}
                    <div
                        data-testid="lookbook-image-1"
                        className="lookbook-card md:col-span-4 md:row-span-2 aspect-square md:aspect-auto bg-black"
                    >
                        <ShareButton
                            eventLabel={`lookbook-${items[1].label}`}
                            title={`FGM Apparel — ${items[1].label}`}
                            text={`${items[1].label} · Built for athletes. Focus. Grind. Motivate.`}
                            path="#lookbook"
                            image={items[1].src}
                        />
                        <ResponsiveImage
                            src={items[1].src}
                            alt={items[1].label}
                            sizes="(max-width: 768px) 100vw, 400px"
                            className="w-full h-full object-contain"
                        />
                        <div className="absolute bottom-0 left-0 right-0 p-5 bg-gradient-to-t from-black via-black/70 to-transparent">
                            <div className="text-[10px] font-display tracking-[0.3em] text-[#E63946] mb-1">
                                {items[1].tag}
                            </div>
                            <div className="font-display text-2xl md:text-3xl text-white uppercase">
                                {items[1].label}
                            </div>
                        </div>
                    </div>

                    {/* Bottom row — Football & Cycling + Soccer */}
                    {items.slice(2, 4).map((it, i) => (
                        <div
                            key={`lookbook-${it.label}`}
                            data-testid={`lookbook-image-${i + 2}`}
                            className="lookbook-card md:col-span-6 aspect-square bg-black"
                        >
                            <ShareButton
                                eventLabel={`lookbook-${it.label}`}
                                title={`FGM Apparel — ${it.label}`}
                                text={`${it.label} · Built for athletes. Focus. Grind. Motivate.`}
                                path="#lookbook"
                                image={it.src}
                            />
                            <ResponsiveImage
                                src={it.src}
                                alt={it.label}
                                sizes="(max-width: 768px) 100vw, 600px"
                                className="w-full h-full object-contain"
                            />
                            <div className="absolute bottom-0 left-0 right-0 p-6 bg-gradient-to-t from-black via-black/70 to-transparent">
                                <div className="text-[10px] font-display tracking-[0.3em] text-[#1D4ED8] mb-1">
                                    {it.tag}
                                </div>
                                <div className="font-display text-2xl md:text-3xl text-white uppercase">
                                    {it.label}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
